import { Component } from '@angular/core';
import { Platform, NavController } from '@ionic/angular';
import { CacheService } from 'ionic-cache';

import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';

declare var Apptentive;

@Component({
  selector: 'app-root',
  templateUrl: 'app.html'
})
export class App {
  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public cache: CacheService
  ) {
    this.initializeApp();
    this.cache.setOfflineInvalidate(true);
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (!this.platform.is('mobileweb') && (this.platform.is('android') || this.platform.is('ios'))) {
        if (this.platform.is('ios')) {
          this.statusBar.overlaysWebView(false);
        }
        this.statusBar.backgroundColorByHexString('#294574');
        this.splashScreen.hide();
        //Add try catch for apprentive so the app doesn't break.
        //Some cases Apptentive had an issue on their end or it tries to fire it when it's not supposed to be used
        try {
          Apptentive.deviceReady();
        } catch (error) {
          console.log('Error: ' + error);
        }

        try {
          Apptentive.addUnreadMessagesListener(
            function(unreadMessages) {
              console.log('UnreadMessages: ' + unreadMessages);
            },
            function(errorMessage) {
              console.log('Error: ' + errorMessage);
            }
          );
        } catch (error) {
          console.log('Error: ' + error);
        }
        // Okay, so the platform is ready and our plugins are available.
        // Here you can do any higher level native things you might need.
      } else {
        this.statusBar.hide();
      }
    });
  }
}
